
import * as net from "@ivanlog/net";
import {LPXProfit} from "./models";
import {NBResult} from "./models";
import {LPXInfo} from "./models";
import {LPXSwapInfo} from "./models";
import {LPXSearchRequest} from "./models";

export class LPXWatcher {
	private readonly _client: net.HTTPClient;
	private readonly _errorsHandler: (e: unknown, args?: unknown) => void;
	/**
	* @param {net.HTTPClient} _client - 
	* @param {(e: unknown, args?: unknown) => void} _errorsHandler - 
	*/
	constructor (_client: net.HTTPClient, _errorsHandler: (e: unknown, args?: unknown) => void){
		this._client = _client;
		this._errorsHandler = _errorsHandler;
		if (!this._errorsHandler) this._errorsHandler = (e, args) => { throw e; };
	}
	
	public async getAPRUnsafe(): Promise<NBResult|Array<LPXProfit>|net.NetError|number> {
		const __endpoint="/LPXWatcher/GetAPR";
		const __query:string[]=[];
		const __addHeaders: Record<string,string> = {};
		__addHeaders['Accept'] = 'application/json';
		let __url = __endpoint;
		const __response = await this._client.process(net.HTTPMethods.GET, __url, undefined, __addHeaders, [200]);
		const __code: number = __response.status;
		let __result;
		try {
			switch(__code) {
				case 200: const __resultArr = await __response.json(); __result=[]; for (const __r of __resultArr) __result.push(new LPXProfit(__r)); break;
				case 401: __result = new NBResult(await __response.json()); break;
				case 403: __result = new NBResult(await __response.json()); break;
				case 422: __result = new NBResult(await __response.json()); break;
				case 500: __result = new NBResult(await __response.json()); break;
				default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
			}
		} catch(e) { throw new net.NetError(net.HTTPCodes.BadDataFormat); }
		if ((__code>=200)&&(__code<300))
		{ if (__result) return __result; else return __code; } else
		{ if (__result) throw __result; else throw new net.NetError(__code); }
	}
	
	/**
	* @param {unknown} errHndlArgs? - args for errorsHandler
	* @returns {Promise<Array<LPXProfit>|undefined>}
	*/
	public async getAPR(errHndlArgs?: unknown): Promise<Array<LPXProfit>|undefined> {
		try {
			const r = await this.getAPRUnsafe();
			if (!(Array.isArray(r))) throw new net.NetError(net.HTTPCodes.UnknownResponse); else return r;
		} catch (e) { this._errorsHandler(e, errHndlArgs); }
	}
	
	/**
	* @param {number} skip - 
	* @param {number} take - 
	* @returns {Promise<NBResult|Array<LPXInfo>|net.NetError|number>}
	*/
	public async getLPXInfoUnsafe(skip: number, take: number): Promise<NBResult|Array<LPXInfo>|net.NetError|number> {
		const __endpoint="/LPXWatcher/GetLPXInfo";
		const __query:string[]=[];
		const __addHeaders: Record<string,string> = {};
		__addHeaders['Accept'] = 'application/json';
		let __url = __endpoint;
		__query.push("skip="+encodeURIComponent(skip));
		__query.push("take="+encodeURIComponent(take));
		__url=__url+'?'+__query.join('&');
		const __response = await this._client.process(net.HTTPMethods.GET, __url, undefined, __addHeaders, [200]);
		const __code: number = __response.status;
		let __result;
		try {
			switch(__code) {
				case 200: const __resultArr = await __response.json(); __result=[]; for (const __r of __resultArr) __result.push(new LPXInfo(__r)); break;
				case 401: __result = new NBResult(await __response.json()); break;
				case 403: __result = new NBResult(await __response.json()); break;
				case 422: __result = new NBResult(await __response.json()); break;
				case 500: __result = new NBResult(await __response.json()); break;
				default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
			}
		} catch(e) { throw new net.NetError(net.HTTPCodes.BadDataFormat); }
		if ((__code>=200)&&(__code<300))
		{ if (__result) return __result; else return __code; } else
		{ if (__result) throw __result; else throw new net.NetError(__code); }
	}
	
	/**
	* @param {number} skip - 
	* @param {number} take - 
	* @param {unknown} errHndlArgs? - args for errorsHandler
	* @returns {Promise<Array<LPXInfo>|undefined>}
	*/
	public async getLPXInfo(skip: number, take: number, errHndlArgs?: unknown): Promise<Array<LPXInfo>|undefined> {
		try {
			const r = await this.getLPXInfoUnsafe(skip, take);
			if (!(Array.isArray(r))) throw new net.NetError(net.HTTPCodes.UnknownResponse); else return r;
		} catch (e) { this._errorsHandler(e, errHndlArgs); }
	}
	
	/**
	* @param {number} skip - 
	* @param {number} take - 
	* @returns {Promise<NBResult|Array<LPXInfo>|net.NetError|number>}
	*/
	public async getHotLPXInfoUnsafe(skip: number, take: number): Promise<NBResult|Array<LPXInfo>|net.NetError|number> {
		const __endpoint="/LPXWatcher/GetHotLPXInfo";
		const __query:string[]=[];
		const __addHeaders: Record<string,string> = {};
		__addHeaders['Accept'] = 'application/json';
		let __url = __endpoint;
		__query.push("skip="+encodeURIComponent(skip));
		__query.push("take="+encodeURIComponent(take));
		__url=__url+'?'+__query.join('&');
		const __response = await this._client.process(net.HTTPMethods.GET, __url, undefined, __addHeaders, [200]);
		const __code: number = __response.status;
		let __result;
		try {
			switch(__code) {
				case 200: const __resultArr = await __response.json(); __result=[]; for (const __r of __resultArr) __result.push(new LPXInfo(__r)); break;
				case 401: __result = new NBResult(await __response.json()); break;
				case 403: __result = new NBResult(await __response.json()); break;
				case 422: __result = new NBResult(await __response.json()); break;
				case 500: __result = new NBResult(await __response.json()); break;
				default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
			}
		} catch(e) { throw new net.NetError(net.HTTPCodes.BadDataFormat); }
		if ((__code>=200)&&(__code<300))
		{ if (__result) return __result; else return __code; } else
		{ if (__result) throw __result; else throw new net.NetError(__code); }
	}
	
	/**
	* @param {number} skip - 
	* @param {number} take - 
	* @param {unknown} errHndlArgs? - args for errorsHandler
	* @returns {Promise<Array<LPXInfo>|undefined>}
	*/
	public async getHotLPXInfo(skip: number, take: number, errHndlArgs?: unknown): Promise<Array<LPXInfo>|undefined> {
		try {
			const r = await this.getHotLPXInfoUnsafe(skip, take);
			if (!(Array.isArray(r))) throw new net.NetError(net.HTTPCodes.UnknownResponse); else return r;
		} catch (e) { this._errorsHandler(e, errHndlArgs); }
	}
	
	/**
	* @param {number} poolId - 
	* @param {number} blockId - 
	* @returns {Promise<NBResult|LPXInfo|net.NetError|number>}
	*/
	public async getLPXByIdLPUnsafe(poolId: number, blockId: number): Promise<NBResult|LPXInfo|net.NetError|number> {
		const __endpoint="/LPXWatcher/GetLPXByIdLP";
		const __query:string[]=[];
		const __addHeaders: Record<string,string> = {};
		__addHeaders['Accept'] = 'application/json';
		let __url = __endpoint;
		__query.push("poolId="+encodeURIComponent(poolId));
		__query.push("blockId="+encodeURIComponent(blockId));
		__url=__url+'?'+__query.join('&');
		const __response = await this._client.process(net.HTTPMethods.GET, __url, undefined, __addHeaders, [200]);
		const __code: number = __response.status;
		let __result;
		try {
			switch(__code) {
				case 200: __result = new LPXInfo(await __response.json()); break;
				case 401: __result = new NBResult(await __response.json()); break;
				case 403: __result = new NBResult(await __response.json()); break;
				case 422: __result = new NBResult(await __response.json()); break;
				case 500: __result = new NBResult(await __response.json()); break;
				default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
			}
		} catch(e) { throw new net.NetError(net.HTTPCodes.BadDataFormat); }
		if ((__code>=200)&&(__code<300))
		{ if (__result) return __result; else return __code; } else
		{ if (__result) throw __result; else throw new net.NetError(__code); }
	}
	
	/**
	* @param {number} poolId - 
	* @param {number} blockId - 
	* @param {unknown} errHndlArgs? - args for errorsHandler
	* @returns {Promise<LPXInfo|undefined>}
	*/
	public async getLPXByIdLP(poolId: number, blockId: number, errHndlArgs?: unknown): Promise<LPXInfo|undefined> {
		try {
			const r = await this.getLPXByIdLPUnsafe(poolId, blockId);
			if (!(r instanceof LPXInfo)) throw new net.NetError(net.HTTPCodes.UnknownResponse); else return r;
		} catch (e) { this._errorsHandler(e, errHndlArgs); }
	}
	
	/**
	* @param {number} poolId - 
	* @param {number} take - 
	* @param {number} beforeTimestamp - 
	* @param {number} direction - 
	* @returns {Promise<NBResult|Array<LPXSwapInfo>|net.NetError|number>}
	*/
	public async getSwapsUnsafe(poolId: number, take: number, beforeTimestamp: number, direction: number): Promise<NBResult|Array<LPXSwapInfo>|net.NetError|number> {
		const __endpoint="/LPXWatcher/GetSwaps";
		const __query:string[]=[];
		const __addHeaders: Record<string,string> = {};
		__addHeaders['Accept'] = 'application/json';
		let __url = __endpoint;
		__query.push("poolId="+encodeURIComponent(poolId));
		__query.push("take="+encodeURIComponent(take));
		__query.push("beforeTimestamp="+encodeURIComponent(beforeTimestamp));
		__query.push("direction="+encodeURIComponent(direction));
		__url=__url+'?'+__query.join('&');
		const __response = await this._client.process(net.HTTPMethods.GET, __url, undefined, __addHeaders, [200]);
		const __code: number = __response.status;
		let __result;
		try {
			switch(__code) {
				case 200: const __resultArr = await __response.json(); __result=[]; for (const __r of __resultArr) __result.push(new LPXSwapInfo(__r)); break;
				case 401: __result = new NBResult(await __response.json()); break;
				case 403: __result = new NBResult(await __response.json()); break;
				case 422: __result = new NBResult(await __response.json()); break;
				case 500: __result = new NBResult(await __response.json()); break;
				default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
			}
		} catch(e) { throw new net.NetError(net.HTTPCodes.BadDataFormat); }
		if ((__code>=200)&&(__code<300))
		{ if (__result) return __result; else return __code; } else
		{ if (__result) throw __result; else throw new net.NetError(__code); }
	}
	
	/**
	* @param {number} poolId - 
	* @param {number} take - 
	* @param {number} beforeTimestamp - 
	* @param {number} direction - 
	* @param {unknown} errHndlArgs? - args for errorsHandler
	* @returns {Promise<Array<LPXSwapInfo>|undefined>}
	*/
	public async getSwaps(poolId: number, take: number, beforeTimestamp: number, direction: number, errHndlArgs?: unknown): Promise<Array<LPXSwapInfo>|undefined> {
		try {
			const r = await this.getSwapsUnsafe(poolId, take, beforeTimestamp, direction);
			if (!(Array.isArray(r))) throw new net.NetError(net.HTTPCodes.UnknownResponse); else return r;
		} catch (e) { this._errorsHandler(e, errHndlArgs); }
	}
	
	/**
	* @param {LPXSearchRequest} request - 
	* @returns {Promise<NBResult|Array<LPXInfo>|net.NetError|number>}
	*/
	public async searchLPXsUnsafe(request: LPXSearchRequest): Promise<NBResult|Array<LPXInfo>|net.NetError|number> {
		const __endpoint="/LPXWatcher/SearchLPXs";
		const __query:string[]=[];
		const __addHeaders: Record<string,string> = {};
		__addHeaders['Accept'] = 'application/json';
		__addHeaders['Content-Type'] = 'application/json';
		let __url = __endpoint;
		let __data;
		const __bodyDataObj = {} as any;
		__bodyDataObj.request = request;
		__data = net.def.objToClearJSON(__bodyDataObj);
		const __response = await this._client.process(net.HTTPMethods.POST, __url, __data, __addHeaders, [200]);
		const __code: number = __response.status;
		let __result;
		try {
			switch(__code) {
				case 200: const __resultArr = await __response.json(); __result=[]; for (const __r of __resultArr) __result.push(new LPXInfo(__r)); break;
				case 401: __result = new NBResult(await __response.json()); break;
				case 403: __result = new NBResult(await __response.json()); break;
				case 422: __result = new NBResult(await __response.json()); break;
				case 500: __result = new NBResult(await __response.json()); break;
				default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
			}
		} catch(e) { throw new net.NetError(net.HTTPCodes.BadDataFormat); }
		if ((__code>=200)&&(__code<300))
		{ if (__result) return __result; else return __code; } else
		{ if (__result) throw __result; else throw new net.NetError(__code); }
	}
	
	/**
	* @param {LPXSearchRequest} request - 
	* @param {unknown} errHndlArgs? - args for errorsHandler
	* @returns {Promise<Array<LPXInfo>|undefined>}
	*/
	public async searchLPXs(request: LPXSearchRequest, errHndlArgs?: unknown): Promise<Array<LPXInfo>|undefined> {
		try {
			const r = await this.searchLPXsUnsafe(request);
			if (!(Array.isArray(r))) throw new net.NetError(net.HTTPCodes.UnknownResponse); else return r;
		} catch (e) { this._errorsHandler(e, errHndlArgs); }
	}
}
